import { memo } from "react";
import { Drawer, Button, Select, Space } from "antd";
import FormItemWrapper from "~/components/common/FormItemWrapper/FormItemWrapper";

interface S2MosaicQuarterlyFilterPanelProps {
  visible: boolean;
  onClose: () => void;
  year?: number;
  setYear: (year?: number) => void;
  quarter?: number;
  setQuarter: (quarter?: number) => void;
  onSearch: () => void;
  onReset: () => void;
}

const S2MosaicQuarterlyFilterPanel: React.FC<S2MosaicQuarterlyFilterPanelProps> = ({
  visible,
  onClose,
  year,
  setYear,
  quarter,
  setQuarter,
  onSearch,
  onReset,
}) => {
  const currentYear = new Date().getFullYear();
  const yearOptions = [
    { label: 'Tất cả các năm (2018 - 2026)', value: undefined as any },
    ...Array.from({ length: 9 }, (_, i) => {
      const y = 2026 - i;
      return { label: `Năm ${y}`, value: y };
    }),
  ];

  const quarterOptions = [
    { label: 'Tất cả các quý', value: undefined as any },
    { label: 'Quý 1 (Tháng 1 - Tháng 3)', value: 1 },
    { label: 'Quý 2 (Tháng 4 - Tháng 6)', value: 2 },
    { label: 'Quý 3 (Tháng 7 - Tháng 9)', value: 3 },
    { label: 'Quý 4 (Tháng 10 - Tháng 12)', value: 4 },
  ];

  return (
    <Drawer
      title="Lọc ảnh Sentinel-2 Ghép Quý"
      placement="right"
      closable={true}
      onClose={onClose}
      open={visible}
      width={380}
      style={{ position: 'absolute' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <FormItemWrapper label="Năm quan sát">
          <Select
            style={{ width: '100%' }}
            placeholder="Tất cả các năm"
            allowClear
            value={year}
            onChange={(val) => setYear(val !== undefined ? Number(val) : undefined)}
            options={yearOptions}
          />
        </FormItemWrapper>

        <FormItemWrapper label="Quý quan sát">
          <Select
            style={{ width: '100%' }}
            placeholder="Tất cả các quý"
            allowClear
            value={quarter}
            onChange={(val) => setQuarter(val !== undefined ? Number(val) : undefined)}
            options={quarterOptions}
          />
        </FormItemWrapper>

        <Space style={{ marginTop: 8 }}>
          <Button type="primary" onClick={onSearch}>
            Tìm kiếm
          </Button>
          <Button onClick={onReset}>
            Đặt lại
          </Button>
        </Space>
      </div>
    </Drawer>
  );
};

export default memo(S2MosaicQuarterlyFilterPanel);
